/* ==========================================================================
   Gift finder
   --------------------------------------------------------------------------
   Builds the four dropdowns from assets/gift-finder-data.js and re-labels
   them whenever the language changes.

   The important detail: only the visible LABEL is translated. Each option's
   value stays the canonical English key ("Mom", "Mama", "Birthday"), because
   that is what is stored in the product metafields and what Shopify filters
   on. So switching language never changes which products match — it only
   changes what the customer reads.
   ========================================================================== */

(function () {
  'use strict';

  function labelFor(data, language, group, key) {
    var pack = data.i18n[language] || data.i18n[data.fallback] || {};
    var map = pack[group] || {};
    return map[key] || key;
  }

  function uiFor(data, language, key) {
    var pack = data.i18n[language] || data.i18n[data.fallback] || {};
    var ui = pack.ui || {};
    if (ui[key]) return ui[key];

    var fallbackPack = data.i18n[data.fallback] || {};
    return (fallbackPack.ui || {})[key] || key;
  }

  function fillSelect(select, keys) {
    var previous = select.value;

    select.textContent = '';

    var blank = document.createElement('option');
    blank.value = '';
    select.appendChild(blank);

    keys.forEach(function (key) {
      var option = document.createElement('option');
      option.value = key;
      // Label text is set by relabel(), so it lives in exactly one place.
      option.textContent = key;
      select.appendChild(option);
    });

    select.value = previous;
  }

  function init(form) {
    if (form.dataset.giftFinderReady === 'true') return;

    var data = window.GIFT_FINDER_DATA;
    if (!data) {
      console.warn('[gift-finder] gift-finder-data.js did not load.');
      return;
    }

    form.dataset.giftFinderReady = 'true';

    var selects = {
      language: form.querySelector('[data-gf-language]'),
      from: form.querySelector('[data-gf-from]'),
      to: form.querySelector('[data-gf-to]'),
      occasion: form.querySelector('[data-gf-occasion]'),
    };

    var labels = {
      language: form.querySelector('[data-gf-label-language]'),
      from: form.querySelector('[data-gf-label-from]'),
      to: form.querySelector('[data-gf-label-to]'),
      occasion: form.querySelector('[data-gf-label-occasion]'),
    };

    var button = form.querySelector('[data-gf-submit]');

    if (!selects.language || !selects.from || !selects.to || !selects.occasion) return;

    /* ---------------------------------------------------------- language */

    selects.language.textContent = '';
    var anyLanguage = document.createElement('option');
    anyLanguage.value = '';
    selects.language.appendChild(anyLanguage);

    data.languages.forEach(function (language) {
      var option = document.createElement('option');
      option.value = language.value;
      option.textContent = language.label;
      selects.language.appendChild(option);
    });

    /* ------------------------------------------------------------ build */

    fillSelect(selects.from, data.relations);
    fillSelect(selects.to, data.relations);
    fillSelect(selects.occasion, data.occasions);

    function relabel() {
      var language = selects.language.value || data.fallback;
      var placeholder = uiFor(data, language, 'placeholder');

      ['from', 'to', 'occasion'].forEach(function (group) {
        var select = selects[group];

        Array.prototype.forEach.call(select.options, function (option) {
          option.textContent =
            option.value === '' ? placeholder : labelFor(data, language, group, option.value);
        });

        if (labels[group]) labels[group].textContent = uiFor(data, language, group);
      });

      if (labels.language) labels.language.textContent = uiFor(data, language, 'language');
      selects.language.options[0].textContent = placeholder;
      if (button) button.textContent = uiFor(data, language, 'button');
    }

    selects.language.addEventListener('change', relabel);
    relabel();

    /* ------------------------------------------------------------ submit
       Disabled controls are omitted from the query string, so a dropdown
       left unselected never appears in the URL. */

    form.addEventListener('submit', function () {
      Object.keys(selects).forEach(function (group) {
        selects[group].disabled = selects[group].value === '';
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-gift-finder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
